import React from 'react';
import { useCallback } from 'react';
import { ContractSelectorWrapper } from './styles.js';

const ContractSelector = ({
  contratoSelecionado,
  contratosCliente,
  setContratoSelecionado,
  tema,
}) => {
  const handleSelectContract = useCallback((contrato) => {
    setContratoSelecionado({ ...contrato });
  }, []);

  const isContractSelected = useCallback(
    (contrato) => {
      return (
        contrato.idContratoCliente === contratoSelecionado.idContratoCliente
      );
    },
    [contratoSelecionado]
  );

  return (
    <ContractSelectorWrapper tema={tema}>
      <div className='title'>
        Selecione o contrato que deseja fazer pagamento
      </div>
      <div className='body'>
        {contratosCliente?.map((contrato) => {
          return (
            <div key={contrato.idContratoCliente} className='contract'>
              <label
                className={
                  isContractSelected(contrato) ? 'contract-checked' : ''
                }
              >
                <input
                  type='radio'
                  value={contrato.nome}
                  checked={isContractSelected(contrato)}
                  onChange={() => handleSelectContract(contrato)}
                />
                {contrato.nome}
              </label>
            </div>
          );
        })}
      </div>
    </ContractSelectorWrapper>
  );
};

export default ContractSelector;
